module.exports = __webpack_public_path__ + "static/media/PrepPlanningIcon.5cd1076b.svg";